define("settings/components/devices/device-item", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    <td class="dd-privacy-mask-user-input">
      <strong>{{@device.name}}</strong>
      <br />
      <span class="u--text--light u--ellipsis">{{@device.ownerEmail}}</span>
    </td>
    <td>{{@device.addedAt}}</td>
    <td>
      {{#if @device.hasNotificationToken}}
        <button
          class="o--btn o--btn--primary {{if this.testNotification.isRunning 'o--btn--disabled'}}"
          onclick={{perform this.testNotification}}
          type="button"
        >
          {{t "account.devices.table.row.test_notification"}}
        </button>
      {{else}}
        <span class="u--text--light">{{@device.warningMessages}}</span>
      {{/if}}
    </td>
    <td>
      {{#if this.canDestroy}}
        <button class="o--btn o--btn--outline" disabled={{@device.isSaving}} onclick={{action @disconnect}} type="button">
          {{t "account.devices.table.row.disconnect"}}
        </button>
      {{/if}}
    </td>
  </tr>
  */
  {
    "id": "on3Rwsbs",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n  \"],[10,\"td\"],[14,0,\"dd-privacy-mask-user-input\"],[12],[1,\"\\n    \"],[10,\"strong\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n    \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--text--light u--ellipsis\"],[12],[1,[30,1,[\"ownerEmail\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,[30,1,[\"addedAt\"]]],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,1,[\"hasNotificationToken\"]],[[[1,\"      \"],[10,\"button\"],[15,0,[29,[\"o--btn o--btn--primary \",[52,[30,0,[\"testNotification\",\"isRunning\"]],\"o--btn--disabled\"]]]],[15,\"onclick\",[28,[37,1],[[30,0,[\"testNotification\"]]],null]],[14,4,\"button\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.devices.table.row.test_notification\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,[30,1,[\"warningMessages\"]]],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,0,[\"canDestroy\"]],[[[1,\"      \"],[10,\"button\"],[14,0,\"o--btn o--btn--outline\"],[15,\"disabled\",[30,1,[\"isSaving\"]]],[15,\"onclick\",[28,[37,3],[[30,0],[30,2]],null]],[14,4,\"button\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.devices.table.row.disconnect\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@device\",\"@disconnect\"],false,[\"if\",\"perform\",\"t\",\"action\"]]",
    "moduleName": "settings/components/devices/device-item.hbs",
    "isStrictMode": false
  });
  let DeviceItemComponent = _exports.default = (_class = class DeviceItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _defineProperty(this, "testNotification", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield this.args.device.testNotification();
            this.alerts.success(this.intl.t('alerts.account.devices.test_notification.success.message'), {
              title: this.intl.t('alerts.account.devices.test_notification.success.title'),
              timeout: 5000
            });
          } catch (e) {
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.account.devices.test_notification.error.title')
            });
          }
        }
      }), null, "testNotification", null));
    }
    get canDestroy() {
      return !(this.args?.numberOfDevices <= 1 && this.auth.currentUserModel.isAccountOwner);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DeviceItemComponent);
});